// extracted by mini-css-extract-plugin
export var templateContent = "index-module--templateContent--eDgFu";
export var video = "index-module--video--Tah8y";